import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { ReplaceableComponentsService } from '@abp/ng.core';
import { eThemeLeptonXComponents } from '@volosoft/abp.ng.theme.lepton-x';
import { SguApplicationLayoutComponent } from './sgu-application-layout.component';

export function initSguApplicationLayout() {
  const replaceableComponents = inject(ReplaceableComponentsService);

  // Override the default LeptonX application layout with our custom one
  replaceableComponents.add({
    key: eThemeLeptonXComponents.ApplicationLayout,
    component: SguApplicationLayoutComponent,
  });
}

export function provideSguApplicationLayout(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      initSguApplicationLayout();
    }),
  ]);
}
